const Collapse = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      {...props}
    >
      <path
        d='M15 7L11 7M11 7L11 3M11 7L17 1'
        stroke='black'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M3 11L7 11M7 11L7 15M7 11L1 17'
        stroke='black'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default Collapse;
